import React from 'react';
import { connect } from 'react-redux';
import DataTable from '@/components/DataTable/DataTable';
import { getPortfolioAction } from '@/actions/trading';
import { dataType } from '@/constants/data-type';
import classnames from 'classnames';
import { getSafe } from '@/helpers/global';
import { Comparator, utilsFunction, formatFunctions, writeFileFunctions, Converter, accessibilityFunctions, keyDownFunctions } from '@/helpers/functions';
import { PARAMS as requestParams } from '@/constants/params';
import TabHeader from '@/components/TabHeader/TabHeader';
import { CUSTOM_STYLES } from '@/constants/app';
import Dropdown from '@/components/Dropdown/Dropdown';
import BlockControl from '@/components/BlockControl/BlockControl';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'
import { stockActions } from '@/actions/trading/stock.action';
import ExportIconDark from '@/assets/images/icons/light/export_icon_dark.png';
import ExportIconLight from '@/assets/images/icons/light/export_icon_light.png';
import { appConfigConstants } from '@/configurations/app-configs/app.config.constants';
import { WS_LANG_KEY } from '@/constants/app';
import { ACTION_TYPE } from "@/constants/w-socket";
import { openMarketPositionProportion } from '@/actions/app'
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';

const icons = {
  exportIcon: {
    dark: ExportIconDark,
    light: ExportIconLight
  }
}

class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [{
        headerName: props.language.common_symbol,
        colId: 'common_symbol',
        field: 'symbol',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.SYMBOL,
        minWidth: 100,
        // cellRendererParams: {
        //   action:  this.toQuotePage.bind(this)
        // }
      },
      {
        headerName: props.language.common_name,
        colId: 'common_name',
        field: 'stockName',
        headerClass: 'table-header',
        cellClass: 'table-cell',
        dataType: dataType.TEXT,
        minWidth:260
      },
      {
        headerName: props.language.common_price,
        colId: 'common_price',
        field: 'price',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell',
        dataType: dataType.CURRENCY,
        comparator: Comparator.numberComparator,
        minWidth: 40,
        // cellRendererParams: {
        //   action:  this.openPlaceorder.bind(this)
        // }
      },
      {
        headerName: props.language.common_change,
        colId: 'common_change',
        field: 'change',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-end',
        bindingColor: true,
        dataType: dataType.CURRENCY,
        comparator: Comparator.numberComparator,
        minWidth:142
      },
      {
        headerName: props.language.common_bid,
        colId: 'common_bid',
        field: 'bid',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-end',
        dataType: dataType.CURRENCY,
        comparator: Comparator.numberComparator,
        minWidth:40
      },
      {
        headerName: props.language.common_ask,
        colId: 'common_ask',
        field: 'ask',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell text-end',
        dataType: dataType.CURRENCY,
        comparator: Comparator.numberComparator,
        minWidth:40
      },
      {
        headerName: props.language.common_position,
        colId: 'common_position',
        field: 'position',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell cell-action',
        dataType: dataType.NUMBER,
        comparator: Comparator.numberComparator,
        minWidth: 80,
      },
      {
        headerName: props.language.common_market_value,
        colId: 'common_market_value',
        field: 'marketv',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell cell-action',
        dataType: dataType.NUMBER,
        comparator: Comparator.numberComparator,
        minWidth: 100,
      },
      {
        headerName: props.language.common_today_PL,
        colId: 'common_today_PL',
        field: 'todayPL',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell cell-action',
        dataType: dataType.PERCENT_BASED,
        bindingColor: true,
        comparator: Comparator.numberComparator,
        minWidth: 150,
      },
      {
        headerName: props.language.common_PL_percent,
        colId: 'common_PL_percent',
        field: 'pl',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell cell-action',
        dataType: dataType.PERCENT_BASED,
        bindingColor: true,
        comparator: Comparator.numberComparator,
        minWidth: 150,
      },
      {
        headerName: props.language.common_ccy,
        colId: 'common_ccy',
        field: 'currencyID',
        headerClass: 'table-header',
        cellClass: 'table-cell cell-action',
        dataType: dataType.TEXT,
        minWidth: 60,
      },
      {
        headerName: props.language.common_today_turnover,
        colId: 'common_today_turnover',
        field: 'todayturnover',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell cell-action',
        dataType: dataType.CASH,
        comparator: Comparator.numberComparator,
        minWidth: 150
      },
      {
        headerName: props.language.common_today_purchase_price,
        colId: 'common_today_purchase_price',
        field: 'todaypurchase',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell cell-action',
        dataType: dataType.CURRENCY,
        comparator: Comparator.numberComparator,
        minWidth: 120
      },
      {
        headerName: props.language.common_today_sales_price,
        colId: 'common_today_sales_price',
        field: 'todaysales',
        headerClass: 'table-header text-end',
        cellClass: 'table-cell cell-action',
        dataType: dataType.CURRENCY,
        comparator: Comparator.numberComparator,
        minWidth: 120
      }],
      data: null,
      portfolio: [{
        id: '1', title: 'portfolio_title', isActive: false
      }],
      totalMarket: '',
      totalFloatingPL: '',
      totalFloatingPLPercent: '',
      marketCode: '',
      productList:[{id: '1', title: 'common_all', isActive: true},{id: '2', title: 'StocksFunds', isActive: false}]
    }
    props.innerRef(this);
  }

  handleChangeMarket = (market) => {
    const marketCode = market ? market.value : '';
    // if (marketCode) {
      this.setState({
        marketCode
      }, () => {
        this.getPortfolio()
      })
    // }
  }

  onChangeproductList=(e)=>{
    this.state.productList.map((item,index)=>{
      if(e === index){
        item.isActive = true
      }else{
        item.isActive = false
      }
      return item
    })
    this.setState({
      productList:this.state.productList
    },()=>{
      this.getPortfolio()
    })
  }
  handExportExcelClick = () => {
    const { columnDefs, data } = this.state
    writeFileFunctions.writeExeclFile({ columnDefs, data, fileName: 'Portfolio.xlsx' })
  }

  getPortfolio = () => {
    let timeout =  setTimeout(() => {
      this.portfolioRef.toggleLoadingOverlay(false);
      this.setState({data : [] , isrefresh : true})
      return
    }, 10000);

    const { user, currentTradingAccount, language , mdsToken} = this.props
    const { clientID,tradingAccSeq } = currentTradingAccount
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      [requestParams.MARKET_ID]: this.state.marketCode,
      [requestParams.TRADING_ACC_SEQ]: tradingAccSeq
    }
    this.portfolioRef.toggleLoadingOverlay(true);
    this.setState({data : [] , isrefresh : true})
    this.props.getAccountPortfolio(params, res => {
      clearTimeout(timeout)
      if (Array.isArray(res.portfoliosList) && res.portfoliosList.length) {
        const lang = this.props.language.lang
        const sample = ['symbol', 'stockName', 'price', 'change','bid' ,'ask', 'position','marketv','todayPL','pl','currencyID','todayturnover', 'todaypurchase' , 'todaysales'].reduce((prev, next) => (prev[next] = '-', prev), {})
        const filted = res.portfoliosList
        const data = []

        for (let i = 0; i <  filted.length; i++) {
          const item = filted[i]
          const deepSample = JSON.parse(JSON.stringify(sample))
          deepSample.symbol = [item.marketID, item.stockCode].join('.')
          deepSample.position= item.ledgerQty
          deepSample.pl = `${formatFunctions.dataFormat(item.floatingPL, dataType.CASH)} (${utilsFunction.datatableFormatPercent(item.floatingPLPercent)})`  
          deepSample.todayPL = `${formatFunctions.dataFormat(item.todayFloatingPL, dataType.CASH)} (${utilsFunction.datatableFormatPercent(item.todayFloatingPLPercent)})`  
          deepSample.currencyID = item.currencyID
          deepSample.marketv = item.marketValue
          deepSample.todaypurchase = item.ttodayConfirmBuy
          deepSample.todaysales = item.ttodayConfirmSell
          if (lang === 'zh_TW' || lang === 'zh_CN') {
            deepSample.stockName = item.stockChineseShortName
            if(!item.stockChineseShortName){
              deepSample.stockName = item.stockName
            }
          } else {
            deepSample.stockName = item.stockName
          }
          if(mdsToken){
            let stockID = item.stockCode.split('').findIndex(i => i !== '0')
            if (stockID > -1) stockID = item.stockCode.substr(stockID)
            const marketID = Converter.mappingWebSocketMarket(item.marketID)
            // const dparams = { instrumentID: item.stockCode, exchangeID: item.marketID }
            if (item.marketID === 'USEX') {
              const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
              stockActions.getBestBidBestAskAction(params, bestBidBestAskRes => {
                const oneNewRowData = JSON.parse(JSON.stringify(this.state.data))
                const deepSample = oneNewRowData?.[i]
                if (deepSample) {
                  deepSample.bid = Array.isArray(bestBidBestAskRes.bestBid) ? bestBidBestAskRes.bestBid?.[0]?.price : bestBidBestAskRes.bestBid?.price
                  deepSample.ask = Array.isArray(bestBidBestAskRes.bestAsk) ? bestBidBestAskRes.bestAsk?.[0]?.price : bestBidBestAskRes.bestAsk?.price 
                  this.setState({ data: oneNewRowData })
                }
              })
              stockActions.getStatisticsAction(params, statisticsRes => {
                const twoNewRowData = JSON.parse(JSON.stringify(this.state.data))
                const deepSample = twoNewRowData?.[i]
                if (deepSample) {
                  deepSample.price = statisticsRes.last
                  stockActions.getClosingPriceAction(params, closingPriceRes => {
                    const threeNewRowData = JSON.parse(JSON.stringify(this.state.data))
                    const deepSample = threeNewRowData?.[i]
                    if (deepSample) {
                      deepSample.change = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)} (${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                      this.setState({ data: threeNewRowData })
                    }
                  })
                  this.setState({ data: twoNewRowData })
                }
              })
            } else {
              const dparams = {
                symbols: [
                  {
                    exchangeID: marketID,
                    key: stockID
                  }
                ],
                sessID:mdsToken
              }
              const params = {
                msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
                symbol: { exchangeID: marketID, key: stockID },
                language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
              }
              this.props.getFinancial(params, financialres => {
                if (financialres && Object.keys(financialres).length) {
                  const oneNewRowData = JSON.parse(JSON.stringify(this.state.data))
                  const deepSample = oneNewRowData?.[i]
                  if(deepSample){
                  this.props.getDetailPriceInfo(dparams, quetores => {
                    if (quetores && Object.keys(quetores).length) {
                      const twoNewRowData = JSON.parse(JSON.stringify(this.state.data))
                      const deepSample = twoNewRowData?.[i]
  
                      deepSample.price = quetores.last
                      // deepSample.turnoverRate = quetores.turnoverRate ? quetores.turnoverRate : '-'
                      deepSample.bid = quetores.bids?.[0]?.price
                      deepSample.ask = quetores.asks?.[0]?.price
                      // deepSample.position = quetores.high
                      // deepSample.todayPL = quetores.low
                      deepSample.todayturnover = quetores.turnover
                      
                      deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                      
                      // if (lang === 'zh_TW') {
                      //   deepSample.stockName = quetores.tcName
                      // } else if (lang === 'zh_CN') {
                      //   deepSample.stockName = quetores.scName
                      // } else {
                      //   deepSample.stockName = quetores.name
                      // }
                      this.setState({ data: twoNewRowData })
                    }
                  })
                  this.setState({ data: oneNewRowData })
                }
                }
              })
            }
          }
          data.push(deepSample)
        }
        this.setState({ data })
      }
      this.setState({isrefresh:false})
      this.portfolioRef.toggleLoadingOverlay(false);
    })
  }

  componentDidMount() {
    const { currentTradingAccount, token, mdsToken } = this.props
    if (currentTradingAccount && token && mdsToken) {
      this.getPortfolio()
    }
  }

  componentDidUpdate(preProps) {
    const { currentTradingAccount, isNeedRefresh, language, mdsToken } = this.props
    if (JSON.stringify(preProps.currentTradingAccount) !=='{}' && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getPortfolio()
    }
    if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
      this.getPortfolio()
    }
    if (language && preProps.language !== language) {
      this.getPortfolio()
    }
    if(preProps.mdsToken != mdsToken && mdsToken){
      this.getPortfolio()
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }


  render() {
    const { language, isMobile, markets, isFilter, autoSize, tabHeader, theme } = this.props;
    const { data, columnDefs, portfolio, totalFloatingPLPercent, totalFloatingPL, productList } = this.state;
    return (
      <React.Fragment>
        <div className={classnames("section-table")}>
          {
            tabHeader && <TabHeader tabs={portfolio} refresh customStyle={CUSTOM_STYLES.HEADER_NORMAL} onRefresh={() => this.getPortfolio()}
              marketFilter={!isFilter && !iTradeEnv?.pages?.trade?.ctrl?.marketFilter} onChangeMarket={this.handleChangeMarket}
            />
          }
          {isFilter && <div className={classnames("section-action-panel")}>
              {productList.map((item,index)=>{
                return  <span className={classnames('section-action-item', item.isActive && 'section-action-active')} 
                key={index} 
                onClick={()=>this.onChangeproductList(index)}
                onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.setState({pageID: item.id},() => {this.getData()}))}
                {...accessibilityFunctions.hasTabIndex()}
                >{language[item.title]}</span>
              })}
              <span style={{marginLeft:'300px',color: theme === 'light' ? '#000' : ''}}>{getSafe(() => language.common_market)}:</span>
              <div className={classnames("section-action-box", "border-style")}>
                <Dropdown selectedOptions={[markets[0]]}
                  options={markets}
                  innerRef={(e) => this.marketRef = e}
                  onChange={(mrk) => this.handleChangeMarket(mrk[0])}
                >
                </Dropdown>
              </div>
              <span className="market_position_proportion" style={{color:"#1e96e3" ,cursor:'pointer'}} 
                    onClick={ this.props.portfolios ? ()=> openMarketPositionProportion() : ()=>{}} 
                    onKeyDown={keyDownFunctions.handleEnterKeyDown(this.props.portfolios ? ()=> openMarketPositionProportion() : ()=>{})}
                   {...accessibilityFunctions.hasTabIndex()}
                > 
                {language.market_position_proportion_title + '  >'} 
              </span>
              <BlockControl auth={appConfigConstants.exportExeclFile}>
                <div className="action-item export-file-wrapper">
                  <button className="export-excel-btn" onClick={this.handExportExcelClick}>
                    <img className="export-icon" src={icons.exportIcon[theme]} />
                    <span>{language.common_export_execl}</span>
                  </button>
                </div>
              </BlockControl>
            </div>}
          <DataTable
            name={TABLE_CONFIGURABLE_KEYS.MY_ACCOUNT_PORTFOLIO_ALL}
            columnDefs={columnDefs}
            data={data}
            innerRef={e => this.portfolioRef = e}
            // autoSizeColumns={autoSize}
          />
        </div>
      </React.Fragment>
    )
  }


  bindingColor(value) {
    if (value > 0) {
      return 'rise-color'
    } else if (value < 0) {
      return 'fall-color'
    } else {
      return ''
    }
  }
}

Portfolio.defaultProps = {
  isFilter: false,
  autoSize: true,
  tabHeader: true,
  innerRef: () => { },
}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets],
    isNeedRefresh: state.refresh.orderTable,
    token: state.auth.token,
    theme: state.app.theme,
    mdsToken: state.trade.mdsToken,
    portfolios: state.trade.portfolios
  }),
  dispatch => ({
    getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
    getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
  })
)(Portfolio)
